import api from './api';

/**
 * WHICH MAILBOX ACTUALLY SENDS. One read, and it is the only honest source for that question.
 *
 * Order forms went out as a Gmail address until 8/31/26 and now go out as support@medeffectsllc.com
 * through Microsoft 365. Which of those is live is decided by MAIL_TRANSPORT on the backend, at
 * runtime - so a page that hardcodes either one is wrong the moment the variable changes, and wrong
 * silently. This endpoint reports the transport that is actually selected and the address it sends
 * as, which is why the Integrations page reads it instead of describing a connection it can see.
 *
 * Admin only, and it returns booleans, the transport name and the sender address - never a token,
 * never the client secret. See mail.controller.ts, which was designed around that constraint.
 */
const mailService = {
  /**
   * `{ transport, label, ... }` plus the active transport's own status: for Microsoft 365,
   * `{ configured, sender, missing[] }`; for Gmail, the same body as /admin/gmail/status.
   *
   * NOTE WHAT `configured` MEANS on the Microsoft path: the four GRAPH_* variables are non-empty.
   * It never contacts Microsoft, so an expired client secret reports configured: true. Proving the
   * credential works needs POST /admin/mail/test, which puts a real message in a real inbox and is
   * therefore deliberately not wired to a button here.
   */
  getStatus: () => api.get('/admin/mail/status'),
};

export default mailService;
